(function () {
	"use strict";

	if (typeof negarshop_addresses_obj === 'undefined') {
		return;
	}

	const citiesMap = negarshop_addresses_obj.cities;
	const ajaxUrl = negarshop_addresses_obj.ajax_url;
	const nonce = negarshop_addresses_obj.nonce;
	const defaultCoords = negarshop_addresses_obj.default_coords && negarshop_addresses_obj.default_coords.length === 2
		? negarshop_addresses_obj.default_coords
		: [35.6892, 51.3890];

	const activeMaps = {};
	const activeMarkers = {};

	function populateCities(provinceSelect, citySelect, selectedCity = '') {
		const provinceCode = provinceSelect.value;
		citySelect.innerHTML = '';
		
		const defaultOpt = document.createElement('option');
		defaultOpt.value = '';
		defaultOpt.textContent = 'انتخاب شهر...';
		citySelect.appendChild(defaultOpt);

		if (provinceCode && citiesMap[provinceCode]) {
			const cities = citiesMap[provinceCode].cities;
			cities.forEach(function (city) {
				const opt = document.createElement('option');
				opt.value = city;
				opt.textContent = city;
				if (city === selectedCity) {
					opt.selected = true;
				}
				citySelect.appendChild(opt);
			});
			citySelect.disabled = false;
			if (window.jQuery && typeof window.jQuery.fn.select2 !== 'undefined') {
				window.jQuery(citySelect).trigger('change.select2');
			}
		} else {
			citySelect.disabled = true;
		}
	}

	function geocodeAndUpdateMap(provinceText, cityText, mapKey) {
		if (!provinceText || !cityText || !activeMaps[mapKey]) {
			return;
		}

		const searchUrl = 'https://nominatim.openstreetmap.org/search?format=json&state=' + encodeURI(provinceText) + '&city=' + encodeURI(cityText);
		fetch(searchUrl)
			.then(res => res.json())
			.then(response => {
				if (response && response.length > 0 && activeMaps[mapKey] && activeMarkers[mapKey]) {
					const lat = parseFloat(response[0].lat);
					const lon = parseFloat(response[0].lon);
					const newLatLng = new L.LatLng(lat, lon);

					activeMarkers[mapKey].setLatLng(newLatLng);
					activeMaps[mapKey].setView(newLatLng, 14);

					const coordsInput = document.getElementById(mapKey.replace('map_', 'coords_'));
					if (coordsInput) {
						coordsInput.value = lat + ',' + lon;
						if (window.jQuery) window.jQuery(coordsInput).trigger('change');
						else coordsInput.dispatchEvent(new Event('change', { bubbles: true }));
					}
				}
			})
			.catch(err => console.error(err));
	}

	function initAddressMap(containerId, initialCoords) {
		const container = document.getElementById(containerId);
		if (!window.L || !container) {
			return null;
		}

		if (activeMaps[containerId]) {
			activeMaps[containerId].remove();
		}

		const coords = initialCoords && initialCoords.length === 2 ? initialCoords : defaultCoords;

		const map = L.map(containerId, {
			center: coords,
			zoom: 14,
			dragging: true
		});

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; OpenStreetMap'
		}).addTo(map);

		const marker = L.marker(coords, {
			draggable: true,
			autoPan: true
		}).addTo(map);

		activeMaps[containerId] = map;
		activeMarkers[containerId] = marker;

		const coordInputId = containerId.replace('map_', 'coords_');
		const coordInput = document.getElementById(coordInputId);

		if (coordInput) {
			coordInput.value = coords[0] + ',' + coords[1];
		}

		marker.on('move', function (e) {
			const latlng = marker.getLatLng();
			if (coordInput) {
				coordInput.value = latlng.lat + ',' + latlng.lng;
				if (window.jQuery) window.jQuery(coordInput).trigger('change');
				else coordInput.dispatchEvent(new Event('change', { bubbles: true }));
			}
		});

		map.on('click', function (e) {
			marker.setLatLng(e.latlng);
			if (coordInput) {
				coordInput.value = e.latlng.lat + ',' + e.latlng.lng;
				if (window.jQuery) window.jQuery(coordInput).trigger('change');
				else coordInput.dispatchEvent(new Event('change', { bubbles: true }));
			}
		});

		container.leafletMap = map;
		container.leafletMarker = marker;
		const inputMap = document.getElementById(containerId.replace('negarshop_map_', ''));
		if (inputMap) {
			inputMap.leafletMap = map;
			inputMap.leafletMarker = marker;
			if (window.jQuery) {
				window.jQuery(inputMap).data('leaflet-map', map);
				window.jQuery(inputMap).data('leaflet-marker', marker);
			}
		}

		return map;
	}

	function selectCheckoutSavedAddress(card) {
		let addressData = card.addressData;
		if (!addressData) {
			const raw = card.getAttribute('data-address');
			if (raw) {
				try {
					addressData = JSON.parse(raw);
				} catch (e) {
					console.error(e);
				}
			}
		}
		if (!addressData) return;

		document.querySelectorAll('.negarshop-address-card').forEach(el => el.classList.remove('active'));
		card.classList.add('active');
		const radio = card.querySelector('.negarshop-address-radio');
		if (radio) radio.checked = true;

		const checkoutForm = document.querySelector('form.checkout');

		const triggerFieldChange = (id, val) => {
			const el = document.getElementById(id);
			if (el) {
				el.value = val;
				if (window.jQuery) window.jQuery(el).trigger('change');
				else el.dispatchEvent(new Event('change', { bubbles: true }));
			}
		};

		Object.keys(addressData).forEach(function(key) {
			if (key.indexOf('billing_') === 0) {
				triggerFieldChange(key, addressData[key]);
			}
		});

		triggerFieldChange('billing_first_name', addressData.billing_first_name || addressData.first_name);
		triggerFieldChange('billing_last_name', addressData.billing_last_name || addressData.last_name);
		triggerFieldChange('billing_phone', addressData.billing_phone || addressData.phone);
		triggerFieldChange('billing_state', addressData.billing_state || addressData.state);
		triggerFieldChange('billing_city', addressData.billing_city || addressData.city);
		triggerFieldChange('billing_address_1', addressData.billing_address_1 || addressData.address);
		triggerFieldChange('billing_postcode', addressData.billing_postcode || addressData.postcode);

		const coordsVal = addressData.billing_map || addressData.coords || '';

		if (checkoutForm) {
			checkoutForm.selectedCoordsBilling = coordsVal;
			if (window.jQuery) {
				window.jQuery(checkoutForm).data('selected-coords-billing', coordsVal);
			}
		}
		const shipDiffCheckbox = document.getElementById('ship-to-different-address-checkbox');
		const shipToDiff = shipDiffCheckbox ? shipDiffCheckbox.checked : false;

		if (!shipToDiff) {
			if (checkoutForm) {
				checkoutForm.selectedCoordsShipping = coordsVal;
				if (window.jQuery) {
					window.jQuery(checkoutForm).data('selected-coords-shipping', coordsVal);
				}
			}
		}

		triggerFieldChange('billing_map_address', coordsVal);
		triggerFieldChange('billing_map', coordsVal);

		if (!shipToDiff) {
			Object.keys(addressData).forEach(function(key) {
				if (key.indexOf('billing_') === 0) {
					const shippingKey = key.replace('billing_', 'shipping_');
					triggerFieldChange(shippingKey, addressData[key]);
				}
			});
			triggerFieldChange('shipping_first_name', addressData.billing_first_name || addressData.first_name);
			triggerFieldChange('shipping_last_name', addressData.billing_last_name || addressData.last_name);
			triggerFieldChange('shipping_state', addressData.billing_state || addressData.state);
			triggerFieldChange('shipping_city', addressData.billing_city || addressData.city);
			triggerFieldChange('shipping_address_1', addressData.billing_address_1 || addressData.address);
			triggerFieldChange('shipping_postcode', addressData.billing_postcode || addressData.postcode);

			triggerFieldChange('shipping_map_address', coordsVal);
			triggerFieldChange('shipping_map', coordsVal);
		} else {
			triggerFieldChange('shipping_map_address', coordsVal);
			triggerFieldChange('shipping_map', coordsVal);
			if (checkoutForm) {
				checkoutForm.selectedCoordsShipping = coordsVal;
				if (window.jQuery) {
					window.jQuery(checkoutForm).data('selected-coords-shipping', coordsVal);
				}
			}
		}

		document.querySelectorAll('.negarshop-consolidated-address-field').forEach(el => {
			const row = el.closest('.form-row');
			if (row) row.style.display = 'none';
		});
		document.querySelectorAll('.negarshop-consolidated-address-wrapper[data-type="billing"]').forEach(el => {
			el.style.display = 'none';
		});

		if (window.jQuery) {
			window.jQuery(document.body).trigger('update_checkout');
		} else {
			document.body.dispatchEvent(new CustomEvent('update_checkout', { bubbles: true }));
		}
	}

	document.addEventListener('DOMContentLoaded', function () {
		document.querySelectorAll('.negarshop-hidden-field').forEach(el => el.style.display = 'none');

		document.querySelectorAll('.negarshop-consolidated-address-wrapper').forEach(wrapper => {
			const type = wrapper.getAttribute('data-type') || 'billing';
			const mapId = 'negarshop_map_' + type;

			let coords = defaultCoords;
			const existingCoordsVal = document.getElementById(type + '_map_address') ? document.getElementById(type + '_map_address').value : '';
			if (existingCoordsVal && existingCoordsVal.split(',').length === 2) {
				coords = existingCoordsVal.split(',').map(Number);
			}

			initAddressMap(mapId, coords);
		});

		const checkoutForm = document.querySelector('form.checkout');
		if (checkoutForm) {
			const activeCard = document.querySelector('.negarshop-address-card.active');
			if (activeCard) {
				selectCheckoutSavedAddress(activeCard);
			}
		}
	});

	document.addEventListener('change', function (e) {
		const provinceSelect = e.target.closest('.negarshop-province-select');
		if (provinceSelect) {
			const container = provinceSelect.closest('.negarshop-consolidated-address-wrapper');
			const type = container ? (container.getAttribute('data-type') || 'billing') : 'billing';
			const citySelect = document.getElementById('negarshop_city_' + type);
			if (citySelect) populateCities(provinceSelect, citySelect);
			return;
		}

		const citySelect = e.target.closest('.negarshop-city-select');
		if (citySelect) {
			const container = citySelect.closest('.negarshop-consolidated-address-wrapper');
			const type = container ? (container.getAttribute('data-type') || 'billing') : 'billing';
			const provSelect = document.getElementById('negarshop_province_' + type);
			const provinceText = provSelect ? provSelect.options[provSelect.selectedIndex].text : '';
			const cityText = citySelect.options[citySelect.selectedIndex].text;
			geocodeAndUpdateMap(provinceText, cityText, 'negarshop_map_' + type);
			return;
		}
	});

	document.addEventListener('input', function (e) {
		mirrorFields(e.target);
	});
	document.addEventListener('change', function (e) {
		mirrorFields(e.target);
	});

	function mirrorFields(target) {
		const wrapper = target.closest('.negarshop-consolidated-address-wrapper');
		if (!wrapper) return;

		const type = wrapper.getAttribute('data-type') || 'billing';

		const stateEl = document.getElementById('negarshop_province_' + type);
		const cityEl = document.getElementById('negarshop_city_' + type);
		const addressEl = document.getElementById('negarshop_address_' + type);
		const postcodeEl = document.getElementById('negarshop_postcode_' + type);
		const coordsEl = document.getElementById('negarshop_coords_' + type);

		const state = stateEl ? stateEl.value : '';
		const city = cityEl ? cityEl.value : '';
		const address = addressEl ? addressEl.value : '';
		const postcode = postcodeEl ? postcodeEl.value : '';
		const coords = coordsEl ? coordsEl.value : '';

		const triggerFieldChange = (id, val) => {
			const el = document.getElementById(id);
			if (el) {
				el.value = val;
				if (window.jQuery) window.jQuery(el).trigger('change');
				else el.dispatchEvent(new Event('change', { bubbles: true }));
			}
		};

		triggerFieldChange(type + '_state', state);
		triggerFieldChange(type + '_city', city);
		triggerFieldChange(type + '_address_1', address);
		triggerFieldChange(type + '_postcode', postcode);

		triggerFieldChange(type + '_map_address', coords);
		triggerFieldChange(type + '_map', coords);
	}

	document.addEventListener('click', function (e) {
		const card = e.target.closest('.negarshop-address-card');
		if (card) {
			const checkoutForm = document.querySelector('form.checkout');
			if (checkoutForm && !e.target.closest('input, button, .negarshop-action-btn')) {
				selectCheckoutSavedAddress(card);
				return;
			}
		}

		// Add new address
		const addBtn = e.target.closest('.negarshop-btn-add-address');
		if (addBtn) {
			const form = document.getElementById('negarshop_address_form');
			if (form) {
				form.reset();
				const addressIdInput = form.querySelector('input[name="address_id"]');
				if (addressIdInput) addressIdInput.value = '';
				const citySelect = document.getElementById('modal_billing_city');
				if (citySelect) {
					citySelect.innerHTML = '<option value="">انتخاب شهر...</option>';
					citySelect.disabled = true;
					if (window.jQuery && typeof window.jQuery.fn.select2 !== 'undefined') {
						window.jQuery(citySelect).trigger('change.select2');
					}
				}
			}
			const modalEl = document.getElementById('negarshop_address_modal');
			if (modalEl) {
				const title = modalEl.querySelector('.modal-title');
				if (title) title.textContent = 'افزودن آدرس جدید';
				if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
					bootstrap.Modal.getOrCreateInstance(modalEl).show();
				}
			}
			if (form) refreshModalMap(form, '');
			return;
		}

		// Edit address
		const editBtn = e.target.closest('.negarshop-btn-edit-address');
		if (editBtn) {
			e.preventDefault();
			const card = editBtn.closest('.negarshop-address-card');
			if (!card) return;

			let addr = card.addressData;
			if (!addr) {
				const raw = card.getAttribute('data-address');
				if (raw) {
					try {
						addr = JSON.parse(raw);
					} catch (e) {
						console.error(e);
					}
				}
			}
			if (!addr) return;

			const form = document.getElementById('negarshop_address_form');
			if (!form) return;

			const addressIdInput = form.querySelector('input[name="address_id"]');
			if (addressIdInput) addressIdInput.value = addr.id || '';
			const titleInput = form.querySelector('input[name="title"]');
			if (titleInput) titleInput.value = addr.title || '';

			const billingKeys = [
				{ key: 'billing_first_name', legacy: 'first_name' },
				{ key: 'billing_last_name', legacy: 'last_name' },
				{ key: 'billing_phone', legacy: 'phone' },
				{ key: 'billing_state', legacy: 'state' },
				{ key: 'billing_city', legacy: 'city' },
				{ key: 'billing_address_1', legacy: 'address' },
				{ key: 'billing_postcode', legacy: 'postcode' }
			];

			Object.keys(addr).forEach(function(key) {
				if (key.indexOf('billing_') === 0 && !billingKeys.some(item => item.key === key)) {
					billingKeys.push({ key: key, legacy: '' });
				}
			});

			const prefix = 'modal_';

			billingKeys.forEach(function(item) {
				const val = (addr[item.key] !== undefined) ? addr[item.key] : addr[item.legacy];
				const field = form.querySelector('[name="' + prefix + item.key + '"]');
				if (field) {
					field.value = val || '';
					if (window.jQuery) window.jQuery(field).trigger('change');
					else field.dispatchEvent(new Event('change', { bubbles: true }));
				}
			});

			const stateSelect = document.getElementById('modal_billing_state');
			const citySelect = document.getElementById('modal_billing_city');
			const selectedCity = addr.billing_city || addr.city || '';

			if (stateSelect && citySelect) {
				populateCities(stateSelect, citySelect, selectedCity);
			}

			const modalEl = document.getElementById('negarshop_address_modal');
			if (modalEl) {
				const title = modalEl.querySelector('.modal-title');
				if (title) title.textContent = 'ویرایش آدرس';
				if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
					bootstrap.Modal.getOrCreateInstance(modalEl).show();
				}
			}
			refreshModalMap(form, addr.billing_map || addr.coords || '');
			return;
		}

		// Delete address
		const deleteBtn = e.target.closest('.negarshop-btn-delete-address');
		if (deleteBtn) {
			e.preventDefault();
			const card = deleteBtn.closest('.negarshop-address-card');
			if (!card) return;
			const addressId = card.getAttribute('data-id');
			if (!addressId) return;

			if (confirm('آیا از حذف این آدرس اطمینان دارید؟')) {
				const isCheckout = document.querySelector('form.checkout') !== null;
				const wasActive = card.classList.contains('active');

				const params = new URLSearchParams();
				params.append('action', 'negarshop_delete_user_address');
				params.append('address_id', addressId);
				params.append('nonce', nonce);
				params.append('is_checkout', isCheckout ? 'true' : 'false');

				fetch(ajaxUrl, {
					method: 'POST',
					headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
					body: params
				})
				.then(res => res.json())
				.then(res => {
					if (res.success) {
						const container = document.querySelector('.negarshop-addresses-manager, .negarshop-checkout-addresses-section');
						if (container) {
							const tempDiv = document.createElement('div');
							tempDiv.innerHTML = res.data.html;
							const newNode = tempDiv.querySelector('.negarshop-addresses-manager, .negarshop-checkout-addresses-section') || tempDiv.firstElementChild || tempDiv.firstChild;
							container.parentNode.replaceChild(newNode, container);
						}

						if (isCheckout) {
							const remainingCards = document.querySelectorAll('.negarshop-address-card');
							if (remainingCards.length) {
								if (wasActive) {
									selectCheckoutSavedAddress(remainingCards[0]);
								} else {
									const active = document.querySelector('.negarshop-address-card.active');
									if (active) {
										selectCheckoutSavedAddress(active);
									}
								}
							} else {
								document.querySelectorAll('.negarshop-consolidated-address-field').forEach(el => {
									const row = el.closest('.form-row');
									if (row) row.style.display = 'block';
								});
								document.querySelectorAll('.negarshop-consolidated-address-wrapper[data-type="billing"]').forEach(el => {
									el.style.display = 'block';
								});
							}
						}
					} else {
						alert(res.data.message || 'خطایی رخ داد.');
					}
				})
				.catch(err => {
					console.error(err);
					alert('خطا در برقراری ارتباط با سرور.');
				});
			}
			return;
		}

		// Set default address
		const defaultBtn = e.target.closest('.negarshop-btn-set-default-address');
		if (defaultBtn) {
			const card = defaultBtn.closest('.negarshop-address-card');
			if (!card) return;
			const addressId = card.getAttribute('data-id');
			if (!addressId) return;

			const isCheckout = document.querySelector('form.checkout') !== null;

			const params = new URLSearchParams();
			params.append('action', 'negarshop_set_default_address');
			params.append('address_id', addressId);
			params.append('nonce', nonce);
			params.append('is_checkout', isCheckout ? 'true' : 'false');

			fetch(ajaxUrl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: params
			})
			.then(res => res.json())
			.then(res => {
				if (res.success) {
					const container = document.querySelector('.negarshop-addresses-manager, .negarshop-checkout-addresses-section');
					if (container) {
						const tempDiv = document.createElement('div');
						tempDiv.innerHTML = res.data.html;
						const newNode = tempDiv.querySelector('.negarshop-addresses-manager, .negarshop-checkout-addresses-section') || tempDiv.firstElementChild || tempDiv.firstChild;
						container.parentNode.replaceChild(newNode, container);
					}
				} else {
					alert(res.data.message || 'خطایی رخ داد.');
				}
			})
			.catch(err => {
				console.error(err);
				alert('خطا در برقراری ارتباط با سرور.');
			});
			return;
		}
	});

	function refreshModalMap(form, coordsVal) {
		const mapInput = form.querySelector('.input-has-map');
		if (!mapInput) return;

		const map = mapInput.leafletMap || (window.jQuery ? window.jQuery(mapInput).data('leaflet-map') : null);
		const marker = mapInput.leafletMarker || (window.jQuery ? window.jQuery(mapInput).data('leaflet-marker') : null);

		if (!map) {
			mapInput.dispatchEvent(new CustomEvent('init', { bubbles: true }));
		}

		let coords = defaultCoords;
		if (coordsVal && coordsVal.split(',').length === 2) {
			coords = coordsVal.split(',').map(Number);
		}

		setTimeout(function () {
			const activeMap = mapInput.leafletMap || (window.jQuery ? window.jQuery(mapInput).data('leaflet-map') : null);
			const activeMarker = mapInput.leafletMarker || (window.jQuery ? window.jQuery(mapInput).data('leaflet-marker') : null);
			if (activeMap && activeMarker) {
				activeMap.invalidateSize();
				activeMap.setView(coords, 14);
				activeMarker.setLatLng(coords);
				mapInput.value = coords[0] + ',' + coords[1];
				if (window.jQuery) window.jQuery(mapInput).trigger('change');
				else mapInput.dispatchEvent(new Event('change', { bubbles: true }));
			}
		}, 250);
	}

	document.addEventListener('change', function (e) {
		const select = e.target.closest('#modal_billing_state');
		if (select) {
			const citySelect = document.getElementById('modal_billing_city');
			if (citySelect) populateCities(select, citySelect);
			return;
		}

		const citySelect = e.target.closest('#modal_billing_city');
		if (citySelect) {
			const stateSelect = document.getElementById('modal_billing_state');
			const provinceText = stateSelect ? stateSelect.options[stateSelect.selectedIndex].text : '';
			const cityText = citySelect.options[citySelect.selectedIndex].text;
			const form = citySelect.closest('form');
			const mapInput = form ? form.querySelector('.input-has-map') : null;
			if (mapInput) {
				const map = mapInput.leafletMap || (window.jQuery ? window.jQuery(mapInput).data('leaflet-map') : null);
				const marker = mapInput.leafletMarker || (window.jQuery ? window.jQuery(mapInput).data('leaflet-marker') : null);

				if (provinceText && cityText && map && marker) {
					const searchUrl = 'https://nominatim.openstreetmap.org/search?format=json&state=' + encodeURI(provinceText) + '&city=' + encodeURI(cityText);
					fetch(searchUrl)
						.then(res => res.json())
						.then(response => {
							if (response && response.length > 0) {
								const lat = parseFloat(response[0].lat);
								const lon = parseFloat(response[0].lon);
								const newLatLng = new L.LatLng(lat, lon);
								marker.setLatLng(newLatLng);
								map.setView(newLatLng, 14);
								mapInput.value = lat + ',' + lon;
								if (window.jQuery) window.jQuery(mapInput).trigger('change');
								else mapInput.dispatchEvent(new Event('change', { bubbles: true }));
							}
						})
						.catch(err => console.error(err));
				}
			}
			return;
		}
	});

	document.addEventListener('submit', function (e) {
		const form = e.target.closest('#negarshop_address_form');
		if (form) {
			e.preventDefault();
			const btn = form.querySelector('.negarshop-modal-save');
			if (btn) {
				btn.disabled = true;
				btn.textContent = 'در حال ثبت...';
			}

			const isCheckout = document.querySelector('form.checkout') !== null;

			const formData = new FormData(form);
			const params = new URLSearchParams();
			formData.forEach((value, key) => {
				params.append(key, value);
			});
			params.append('action', 'negarshop_save_user_address');
			params.append('nonce', nonce);
			params.append('is_checkout', isCheckout ? 'true' : 'false');

			fetch(ajaxUrl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: params
			})
			.then(res => res.json())
			.then(res => {
				if (btn) {
					btn.disabled = false;
					btn.textContent = 'ثبت آدرس';
				}
				if (res.success) {
					const modalEl = document.getElementById('negarshop_address_modal');
					if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
						bootstrap.Modal.getOrCreateInstance(modalEl).hide();
					}

					const container = document.querySelector('.negarshop-addresses-manager, .negarshop-checkout-addresses-section');
					if (container) {
						const tempDiv = document.createElement('div');
						tempDiv.innerHTML = res.data.html;
						const newNode = tempDiv.querySelector('.negarshop-addresses-manager, .negarshop-checkout-addresses-section') || tempDiv.firstElementChild || tempDiv.firstChild;
						container.parentNode.replaceChild(newNode, container);
					}

					if (isCheckout) {
						const newCard = document.querySelector('.negarshop-address-card[data-id="' + res.data.address_id + '"]');
						if (newCard) {
							selectCheckoutSavedAddress(newCard);
						}
					}
				} else {
					alert(res.data.message || 'خطایی رخ داد.');
				}
			})
			.catch(err => {
				console.error(err);
				if (btn) {
					btn.disabled = false;
					btn.textContent = 'ثبت آدرس';
				}
				alert('خطا در برقراری ارتباط با سرور.');
			});
		}
	});

})();
